import { useState } from "react";
import { Link } from "react-router-dom";
import { categories, mainSiteUrl } from "@/mocks/siteData";

export default function Navbar() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isCatExpanded, setIsCatExpanded] = useState(false);

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-white shadow-sm border-b border-background-200/70">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 shrink-0 cursor-pointer">
            <div className="w-8 h-8 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className="ri-file-list-3-line text-background-50 text-lg"></i>
            </div>
            <span className="font-heading text-lg font-semibold text-foreground-900 whitespace-nowrap">
              BaseTao Sheet
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-6">
            <Link to="/" className="text-sm font-semibold text-foreground-900 hover:text-primary-600 whitespace-nowrap cursor-pointer transition-colors">
              Home
            </Link>

            <div className="relative">
              <button
                onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                className="flex items-center gap-1.5 text-sm font-medium text-foreground-700 hover:text-primary-600 whitespace-nowrap cursor-pointer transition-colors"
              >
                Categories
                <i className={`ri-arrow-down-s-line text-base transition-transform duration-200 ${isDropdownOpen ? "rotate-180" : ""}`}></i>
              </button>

              {isDropdownOpen && (
                <>
                  <div className="fixed inset-0 z-40" onClick={() => setIsDropdownOpen(false)}></div>
                  <div className="absolute top-full left-1/2 -translate-x-1/2 mt-2 w-64 bg-white rounded-lg border border-background-200/80 shadow-lg py-2 max-h-80 overflow-y-auto z-50">
                    {categories.map((cat) => (
                      <a
                        key={cat.name}
                        href={cat.url}
                        target="_blank"
                        rel="noopener nofollow"
                        className="flex items-center gap-3 px-4 py-2.5 text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-700 transition-colors cursor-pointer"
                        onClick={() => setIsDropdownOpen(false)}
                      >
                        <div className="w-7 h-7 flex items-center justify-center">
                          <i className={`${cat.icon} text-base text-primary-500`}></i>
                        </div>
                        <span dangerouslySetInnerHTML={{ __html: cat.name }}></span>
                      </a>
                    ))}
                  </div>
                </>
              )}
            </div>

            <Link to="/article/basetao-shopping-guide" className="text-sm font-medium text-foreground-700 hover:text-primary-600 whitespace-nowrap cursor-pointer transition-colors">
              Shopping Guide
            </Link>

            <Link to="/article/basetao-review" className="text-sm font-medium text-foreground-700 hover:text-primary-600 whitespace-nowrap cursor-pointer transition-colors">
              Reviews
            </Link>

            <Link to="/article/basetao-spreadsheet-guide" className="text-sm font-medium text-foreground-700 hover:text-primary-600 whitespace-nowrap cursor-pointer transition-colors">
              FAQ
            </Link>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="px-4 py-2 text-sm font-medium text-primary-700 border border-primary-300 rounded-md hover:bg-primary-50 transition-colors whitespace-nowrap cursor-pointer"
            >
              BaseTao Spreadsheet
            </a>
            <a
              href={mainSiteUrl}
              target="_blank"
              rel="noopener nofollow"
              className="px-4 py-2 text-sm font-semibold text-background-50 bg-primary-500 rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              Buy It Now
            </a>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            aria-label="Toggle menu"
          >
            <i className={`text-xl text-foreground-900 ${isMobileMenuOpen ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>

        {isMobileMenuOpen && (
          <div className="md:hidden border-t border-background-200/70 py-4 bg-white max-h-[70vh] overflow-y-auto">
            <div className="flex flex-col gap-1">
              <Link
                to="/"
                className="flex items-center gap-3 px-3 py-2.5 text-sm font-semibold text-foreground-900 hover:bg-background-100 rounded-md cursor-pointer"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-home-4-line text-primary-500"></i>
                </div>
                Home
              </Link>

              <Link
                to="/article/basetao-shopping-guide"
                className="flex items-center gap-3 px-3 py-2.5 text-sm font-semibold text-foreground-900 hover:bg-background-100 rounded-md cursor-pointer"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-book-open-line text-primary-500"></i>
                </div>
                Shopping Guide
              </Link>

              <Link
                to="/article/basetao-spreadsheet-guide"
                className="flex items-center gap-3 px-3 py-2.5 text-sm font-medium text-foreground-700 hover:bg-background-100 rounded-md cursor-pointer"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-guide-line text-foreground-500"></i>
                </div>
                Spreadsheet Guide
              </Link>

              <Link
                to="/article/basetao-review"
                className="flex items-center gap-3 px-3 py-2.5 text-sm font-medium text-foreground-700 hover:bg-background-100 rounded-md cursor-pointer"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                <div className="w-6 h-6 flex items-center justify-center">
                  <i className="ri-star-line text-foreground-500"></i>
                </div>
                BaseTao Review
              </Link>

              <button
                onClick={() => setIsCatExpanded(!isCatExpanded)}
                className="flex items-center justify-between w-full px-3 py-2.5 text-sm font-semibold text-foreground-900 hover:bg-background-100 rounded-md cursor-pointer mt-2"
              >
                <span className="flex items-center gap-3">
                  <div className="w-6 h-6 flex items-center justify-center">
                    <i className="ri-grid-line text-accent-500"></i>
                  </div>
                  Shop by Category
                </span>
                <i className={`ri-arrow-down-s-line text-base transition-transform ${isCatExpanded ? "rotate-180" : ""}`}></i>
              </button>

              {isCatExpanded && (
                <div className="grid grid-cols-2 gap-1 px-1 py-2">
                  {categories.map((cat) => (
                    <a
                      key={cat.name}
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="flex items-center gap-2 px-3 py-2 text-xs text-foreground-700 hover:bg-primary-50 hover:text-primary-700 rounded-md transition-colors cursor-pointer"
                      onClick={() => setIsMobileMenuOpen(false)}
                    >
                      <div className="w-5 h-5 flex items-center justify-center">
                        <i className={`${cat.icon} text-xs text-primary-500`}></i>
                      </div>
                      <span dangerouslySetInnerHTML={{ __html: cat.name }} className="truncate"></span>
                    </a>
                  ))}
                </div>
              )}

              <div className="flex flex-col gap-2 pt-3 mt-2 border-t border-background-200/70">
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="px-3 py-2.5 text-sm font-medium text-primary-700 border border-primary-300 rounded-md text-center hover:bg-primary-50 transition-colors cursor-pointer"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  BaseTao Spreadsheet
                </a>
                <a
                  href={mainSiteUrl}
                  target="_blank"
                  rel="noopener nofollow"
                  className="px-3 py-2.5 text-sm font-semibold text-background-50 bg-primary-500 rounded-md text-center hover:bg-primary-600 transition-colors cursor-pointer"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  Buy It Now
                </a>
              </div>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
}